import "@mdi/font/css/materialdesignicons.css"
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                anchor: "#000000",
                background: "#FFFFFF",
                error: '#f94144',
                color1: '#ebeff0',
                color2: '#dcdcdd',
                color3: '#2a5478',
                color4: '#041829',
                color5: "#5b5c79"
            }
        }
    },
    icons: {
        iconfont: "mdi"
    }
});
